<template>
  <ValidationObserver ref="observer-user" tag="div" class="uk-form-stacked">
    <div class="uk-margin">
      <ValidationProvider v-slot="{ errors }" rules="required">
        <label class="uk-form-label uk-text-bold" for="fname" :class="{ 'uk-text-danger': errors.length }">First Name</label>
        <div class="uk-form-controls">
          <input id="fname" v-model="form.name.first" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="fname" data-cy="user-form-fname">
        </div>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="uk-margin">
      <ValidationProvider v-slot="{ errors }" rules="required">
        <label class="uk-form-label uk-text-bold" for="lname" :class="{ 'uk-text-danger': errors.length }">Last Name</label>
        <div class="uk-form-controls">
          <input id="lname" v-model="form.name.last" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="lname" data-cy="user-form-lname">
        </div>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="uk-margin">
      <ValidationProvider v-slot="{ errors }" rules="required|email">
        <label class="uk-form-label uk-text-bold" for="email" :class="{ 'uk-text-danger': errors.length }">Email</label>
        <div class="uk-form-controls">
          <input id="email" v-model="form.email" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="email" data-cy="user-form-email">
        </div>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="uk-margin-small">
      <ValidationProvider v-slot="{ errors }" :rules="`${passwordRules}|confirmed:passwordConfirmation`">
        <div class="uk-form-label uk-text-bold" for="password" :class="{ 'uk-text-danger': errors.length }">Password</div>
        <div class="uk-form-controls">
          <input id="password" v-model="form.password" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="password" data-cy="user-form-password">
        </div>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>

    <div class="uk-margin-small">
      <ValidationProvider v-slot="{ errors }" :rules="passwordRules" vid="passwordConfirmation">
        <div class="uk-form-label uk-text-bold" for="password-confirm" :class="{ 'uk-text-danger': errors.length }">Confirm Password</div>
        <div class="uk-form-controls">
          <input id="password-confirm" v-model="form.passwordConfirm" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="password-confirm" data-cy="user-form-passwordconfirm">
        </div>
        <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'ComponentFormUser',

  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: {
    type: {
      type: String,
      required: true
    },

    user: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      observer: null,
      form: {
        email: null,
        password: null,
        passwordConfirm: null,
        name: {
          first: null,
          last: null
        }
      }
    }
  },

  computed: {
    passwordRules() {
      return this.type === 'new' ? 'required|min:6' : 'min:6'
    }
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit('update:form', this.form)
      }
    }
  },

  created() {
    if (this.type === 'manage') {
      this.form.email = this.user.email
      this.form.name.first = this.user.name.first
      this.form.name.last = this.user.name.last
    }
  },

  mounted() {
    this.observer = this.$refs['observer-user']
  },

  methods: {
    async validate() {
      return this.observer.validate()
    }
  }
}
</script>
